import React, { useState, useContext } from "react";
import '../componentsCSS/Login.css' // Importer le CSS spécifique à ce composant
import { FaLock, FaEnvelope } from "react-icons/fa";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";

const LoginPopup = ({ onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { loginUser, updateUserData } = useContext(UserContext);
  const navigate = useNavigate();

  // Vérification de connexion basée sur userData
  const isConnected = Boolean(updateUserData && updateUserData.uid);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
        // Appeler la méthode du contexte pour effectuer la connexion
        await loginUser(email, password);

        // Rediriger après une connexion réussie
        console.log("Connexion réussie, redirection...");
        navigate("/calendrier"); // Exemple de redirection vers la page principale
    } catch (error) {
        console.error("Erreur lors de la connexion :", error);
        setError("Une erreur est survenue lors de la connexion. Veuillez réessayer.");
    }
};

  return (
    <div className="login-popup-overlay" onClick={onClose}>
      <div 
      className={`wrapper ${isConnected ? "connected-screen" :  "login-mode"}`} // Ajoute une classe dynamique
      onClick={(e) => e.stopPropagation()}>
        <form 
          onSubmit={handleLogin}
          className="form-box"
          >
            <h2>{"Connexion"}</h2>
            <div className="input-box">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <FaEnvelope className="icon"/>
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <FaLock className="icon" />
            </div>

           {/* TODO : ajouter le onclick de mot de passe oublier */}
          {/* {!isRegisterMode && ( // Affiche la section "Se souvenir de moi" et "Mot de passe oublié" uniquement en mode connexion
            <div className="remember-forgot">
              <label><input type="checkbox" /> Se souvenir de moi</label>
              <a href="#temp" >Mot de passe oublié</a> 
            </div>
          )} */}

          <button type="submit" className="submit-button">Se connecter</button>
          
            <div className="register">
              <p>Vous n'avez pas de compte ?
                <a 
                  href="/"
                  className="link-button"
                >
                S'inscrire</a>
              </p>
            </div>
            {error && <p className="error-message">{error}</p>}
          </form>
      </div>
    </div>
  );
};

export default LoginPopup;
